import { render, staticRenderFns } from "./MemoryGame.vue?vue&type=template&id=ec632f18&scoped=true&"
import script from "./MemoryGame.vue?vue&type=script&lang=js&"
export * from "./MemoryGame.vue?vue&type=script&lang=js&"
import style0 from "./MemoryGame.vue?vue&type=style&index=0&id=ec632f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec632f18",
  null
  
)

export default component.exports